import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-capabilities-block.css.lit';

import './se-capabilities-list';

export type CapabilitiesItem = {
  text: string;
  url: string;
};

export type Capability = Array<CapabilitiesItem>;

export type SeCapabilitiesBlockItemType = 'industries' | 'services';

/**
 * The SeCapabilitiesBlock component
 * @element se-capabilities-block
 */
@customElement('se-capabilities-block')
export class SeCapabilitiesBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Array of {text: , url: }
   */
  @property({ type: Array })
  industries: Capability;

  /**
   * Array of {text: , url: }
   */
  @property({ type: Array })
  services: Capability;

  render(): TemplateResult {
    return html`
      <section class="capabilities-block">
        <nav class="capabilities-block--nav" aria-label="capabilities menu">
          <ul class="capabilities-block--main">
            ${this.services
              ? html`
                  <li class="capabilities-block--main-item">
                    <se-capabilities-list
                      .capability=${this.services}
                      type="services"
                    ></se-capabilities-list>
                  </li>
                `
              : null}
            ${this.industries
              ? html`
                  <li class="capabilities-block--main-item">
                    <se-capabilities-list
                      .capability=${this.industries}
                      type="industries"
                    ></se-capabilities-list>
                  </li>
                `
              : null}
          </ul>
        </nav>
      </section>
    `;
  }
}
